module.exports = __webpack_public_path__ + "static/media/icon-insta-black.1d3bd5fb.svg";